import React, { useEffect, useState } from 'react';
// material-ui
import { Typography } from '@mui/material';

// project imports
import NavGroup from './NavGroup';

import getSidebarItems from '../../../../menu-items/other';

// ==============================|| SIDEBAR MENU LIST ||============================== //

const MenuList = () => {
    const [, setMenuTick] = useState(0);
    useEffect(() => {
        const refresh = () => setMenuTick((n) => n + 1);
        window.addEventListener('userDataUpdated', refresh);
        return () => window.removeEventListener('userDataUpdated', refresh);
    }, []);

    const userData = JSON.parse(localStorage.getItem('userData') || '{}');
    const role = userData?.role || 'default';
    const navItems = [getSidebarItems(role)].map((item) => {
        switch (item.type) {
            case 'group':
                return <NavGroup key={item.id} item={item} />;
            default:
                return (
                    <Typography key={item.id} variant="h6" color="error" align="center">
                        Menu Items Error
                    </Typography>
                );
        }
    });

    return <>{navItems}</>;
};

export default MenuList;
